module.exports = __webpack_public_path__ + "img/justice.c8c66151.svg";